/** Runtime env for Telegram auth — Next.js prod may inline empty process.env at build time. */
export function runtimeEnv(name: string): string {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  return require("node:process").env[name] || "";
}

export function runtimeWebappUrl(): string {
  const url =
    runtimeEnv("NEXT_PUBLIC_WEBAPP_URL") ||
    runtimeEnv("WEBAPP_URL") ||
    runtimeEnv("NEXTAUTH_URL") ||
    runtimeEnv("NEXT_PUBLIC_WEBSITE_URL") ||
    "https://book.knopka.click";

  if (!/^https?:\/\//i.test(url)) {
    throw new Error(`Invalid webapp URL: ${url || "(empty)"}`);
  }

  return url.replace(/\/$/, "");
}

export function runtimeEncryptionSecret(): Uint8Array {
  const key = runtimeEnv("CALENDSO_ENCRYPTION_KEY");
  if (!key) throw new Error("CALENDSO_ENCRYPTION_KEY is not configured");
  return new TextEncoder().encode(key);
}

const DEFAULT_BOOKING_INTERNAL_HOST = "172.17.0.1";

export function bookingInternalHost(): string {
  return runtimeEnv("BOOKING_INTERNAL_HOST") || DEFAULT_BOOKING_INTERNAL_HOST;
}

export function bookingInternalSecret(): string {
  return runtimeEnv("BOOKING_INTERNAL_SECRET").trim();
}

export function bookingInternalEventTranslationUrl(): string {
  return (
    runtimeEnv("BOOKING_INTERNAL_URL") ||
    `http://${bookingInternalHost()}:1337/booking/api/internal/event-translation`
  ).trim();
}

export function bookingInternalInvalidateUrl(): string {
  return (
    runtimeEnv("BOOKING_INTERNAL_INVALIDATE_URL") ||
    `http://${bookingInternalHost()}:1337/booking/api/internal/event-translation/invalidate`
  ).trim();
}

export function bookingPublicTranslationUrl(): string {
  return (
    runtimeEnv("BOOKING_PUBLIC_TRANSLATION_URL") ||
    `http://${bookingInternalHost()}:1337/booking/api/public/event-translation`
  ).trim();
}

/** Validate same-origin relative redirect paths without needing WEBAPP_URL. */
export function safeSameOriginPath(path: string | null | undefined): string | null {
  const trimmed = (path || "").trim();
  if (!trimmed.startsWith("/") || trimmed.startsWith("//")) return null;
  if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(trimmed)) return null;
  return trimmed;
}
